import  AzureService  from 'src/app/shared/services/azure.service';
import { Component, Inject, OnInit, signal } from '@angular/core';
import { MsalBroadcastService, MsalGuardConfiguration, MsalService, MSAL_GUARD_CONFIG } from '@azure/msal-angular';
import { AccountInfo, InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { filter } from 'rxjs';
import { IProfile } from '../../interfaces/azure/userprofile.interface';


@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit{

  // Signals: escritos em callbacks assincronos (inProgress$ do MSAL e a resposta do
  // Graph) e lidos no template. Com CD zoneless, campo comum nao dispara renderizacao.
  public readonly isUserAuthenticated = signal(false)
  public readonly userProfile = signal<IProfile | undefined>(undefined)

  constructor(
              @Inject(MSAL_GUARD_CONFIG) private msalGuardConfig: MsalGuardConfiguration,
              private authService: MsalService,
              private msalBroadCastService: MsalBroadcastService,
              private azureService: AzureService
            ) { }

  ngOnInit() {
    this.msalBroadCastService.inProgress$.pipe(
      filter((interactionStatus: InteractionStatus) =>
        interactionStatus === InteractionStatus.None
      ))
      .subscribe(() => {
        const accounts = this.authService.instance.getAllAccounts()
        this.isUserAuthenticated.set(accounts.length > 0);

        if(this.isUserAuthenticated()) {
          this.ensureActiveAccount(accounts[0])
          this.getUserProfile()
        }
      })
  }

  // Fluxo de redirect, coerente com o InteractionType.Redirect ja configurado no
  // MsalGuard e no MsalInterceptor. O popup foi abandonado porque o msal-browser v5
  // passou a devolver a resposta por BroadcastChannel, exigindo que a pagina do
  // redirectUri seja enxuta -- e aqui ela e a raiz do SPA.
  //
  // Sempre via MsalService, nunca via authService.instance.*: desde o msal-browser v3
  // a PublicClientApplication exige initialize() antes de qualquer chamada de auth, e
  // apenas os metodos do wrapper do msal-angular garantem isso.
  //
  // Nao ha handler de sucesso: a pagina navega para o login e, na volta, quem atualiza
  // o estado e a inscricao em inProgress$ do ngOnInit. O MsalRedirectComponent
  // (bootstrapped no AppModule) processa a resposta.
  public login() {
    const authRequest = this.msalGuardConfig.authRequest as RedirectRequest | undefined

    this.authService.loginRedirect(authRequest).subscribe({
      error: error => console.error('Falha no login', error)
    })
  }

  public logout() {
    this.authService.logoutRedirect().subscribe({
      error: error => console.error('Falha no logout', error)
    })
  }

  // O msal v3+ deixou de eleger a conta ativa automaticamente quando existe apenas uma
  // em cache. Sem conta ativa o MsalInterceptor nao consegue anexar tokens as requests.
  private ensureActiveAccount(account: AccountInfo | null) {
    if (account && !this.authService.instance.getActiveAccount()) {
      this.authService.instance.setActiveAccount(account)
    }
  }

  private getUserProfile() {    
    this.azureService.getUserProfile()
    .subscribe(profile => {            
      this.userProfile.set(profile);
    })
  }

}
